import PropTypes from 'prop-types';

import { Box, Button } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const RetryButton = ({ title, onClick }) => (
  <Button type="button" variant="contained" disableElevation onClick={onClick}>
    {title}
  </Button>
);

RetryButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

const RetryContainer = (props) => {
  const { children } = props;
  return (
    <Box mb="1rem" mt={0} position="relative" zIndex={1}>
      {children}
    </Box>
  );
};

RetryContainer.propTypes = {
  children: PropTypes.instanceOf(Object),
};

const LoadingPlaceholder = (props) => {
  const { error, timedOut, pastDelay, retry } = props;

  const { t } = useTransl();

  if (error) {
    return (
      <RetryContainer>
        <RetryButton title={t('actions.retryIfSlowNet')} onClick={retry} />
      </RetryContainer>
    );
  }
  if (timedOut) {
    return (
      <RetryContainer>
        <RetryButton title={t('actions.retryIfLongTime')} onClick={retry} />
      </RetryContainer>
    );
  }
  if (pastDelay) {
    return <Box m="1rem">{t('common.loading')}</Box>;
  }
  return null;
};

LoadingPlaceholder.propTypes = {
  error: PropTypes.instanceOf(Object),
  timedOut: PropTypes.bool,
  pastDelay: PropTypes.bool,
  retry: PropTypes.func,
};

export default LoadingPlaceholder;
